<div class="u-center overFlow max-width" style="overflow-x:auto" #container [ngClass]="!visible ? 'global-unmount' : ''">
  <ul class="stepper list-group list-group-horizontal u-mt20" *ngIf="requirementStatus" [ngClass]="{
    'stepper--small': variant === 'tiny',
    'center-flow-steps': variant === 'full' && centered,
    'custom-stepper-full': variant === 'full',
    'custom-stepper-tiny': variant === 'tiny'
  }"
  >
    <ng-container>
      <li *ngFor="let step of requirementStatus" class=" stepper__step list-group-item p-0 border-0 "
        [ngClass]="{
          'stepper__step--approved': step.approved === 'Aprobado',
          'stepper__step--rejected': step.approved === 'Rechazado'
        }"
        (mouseenter)="onHover($event, step)"
        (mouseleave)="onLeaving($event, step)"
      >
        <div class="rounded-circle " [ngClass]="{
          'correct-icon-position-tiny-approved': (step.approved && step.approved !== 'Pendiente' && step.date) && variant === 'tiny',
          'correct-icon-position-full-approved': (step.approved && step.approved !== 'Pendiente' && step.date) && variant === 'full',
          'correct-icon-position-tiny-pending': step.approved === 'Pendiente' && variant === 'tiny',
          'correct-icon-position-full-pending': step.approved === 'Pendiente' && variant === 'full',
          'correct-icon-position-full-rejected': step.date && !step.approved && variant === 'full',
          'correct-icon-position-tiny-rejected': step.date && !step.approved && variant === 'tiny'
        }">
        </div>
        <p *ngIf="!withDate"> {{step.name}}</p>
        <p *ngIf="withDate">
          {{step.name}}<br>
          {{step.date | date: 'dd/MM/yyyy'}}
        </p>
      </li>
    </ng-container>

  </ul>
</div>
